(() => {
    // Code innerhalb dieses Blocks ist kapsuliert, sodass keine Variablen oder Funktionen global verfügbar sind.
    document.addEventListener('DOMContentLoaded', () => {
        const wrapper = document.getElementById('iww-image-rights-container');
        if (!wrapper) return;

        const toggleBtn = document.querySelector('#iww-image-rights-btn');
        const closeBtn = wrapper.querySelector('#iww-image-rights-close');
        const contentContainer = document.querySelector('#iww-image-rights-content');

        const toggleAriaHidden = el =>
            el.setAttribute('aria-hidden', String(el.getAttribute('aria-hidden') !== 'true'));

        const formatImageSource = title => {
            const index = title.indexOf('(Bild:');
            if (index === -1) return '';
            let source = title.slice(index + 6).trim()
                              .replace(/^[\s"'(]+|[\s"')]+$/g, '')
                              .replace(/[)\uFF09]+$/g, '')
                              .trim();
            return /^(©|\(c\)|&copy;)/i.test(source) ? source : `© ${source}`;
        };

        const createPicsourceItem = (container, img) => {
            if (!img.title) return;
            // Schon vorhanden?
            if (container.querySelector(`.iww-picsource__item[data-title="${img.title}"]`)) return;

            const item = document.createElement('div');
            item.className = 'iww-picsource__item w-full md:w-[48%] md:flex items-start mb-4';
            item.dataset.title = img.title;

            item.innerHTML = `
            <figure class="iww-picsource__img mr-[1em]">
              <picture class="iww-imgwrapper iww-imgwrapper--169">
                <img class="w-full sm:w-[150px] object-cover" src="${img.src}" alt="${img.alt || ''}" title="${img.title}"/>
              </picture>
            </figure>
          `;

            const sourceText = document.createElement('p');
            sourceText.className = 'iww-picsource__text text-left';
            sourceText.innerText = formatImageSource(img.title);

            item.append(sourceText);
            container.append(item);
        };

        const buildFooterImages = () => {
            if (!contentContainer) return;

            const images = document.querySelectorAll('img[title]:not(.js-ignore-picsource)');
            images.forEach(img => {
                if (!img.title || !img.title.includes('(Bild:')) return;
                createPicsourceItem(contentContainer, img);
            });
        };

        const resetFooter = () => {
            if (!contentContainer) return;
            contentContainer.querySelectorAll('.iww-picsource__item, .iww-picsource__text')
                                 .forEach(el => el.remove());
        };

        // Klick auf Toggle-Button
        if (toggleBtn) {
            toggleBtn.addEventListener('click', () => {
                toggleAriaHidden(wrapper);
                buildFooterImages();
            });
        }

        // Klick innerhalb Wrapper → nicht nach außen propagieren
        wrapper.addEventListener('click', e => e.stopPropagation());

        // Klick auf Close-Button
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                toggleAriaHidden(wrapper);
            });
        }

        // Event nach htmx-Aktionen
        document.addEventListener('htmx:afterSettle', () => {
            wrapper.setAttribute('aria-hidden', 'false');
            resetFooter();
        });

        // MutationObserver für dynamische Bilder
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1 || !node.matches('img[title]:not(.js-ignore-picsource)')) return;
                    if (contentContainer) createPicsourceItem(contentContainer, node);
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
})();
